(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["student-debt"] && !window.DesignMode) return;
  try {
    
  //update the clock every X seconds (Example: 1 second)
  var seconds = 1;
  var startAmount = 883000000000;
  var t1 = new Date();
  var t2 = new Date(2010, 06, 01, 0, 0, 0, 0);
  var dif = t1.getTime() - t2.getTime();
  
  var Seconds_from_T1_to_T2 = dif / 1000;
  var Seconds_Between_Dates = Math.abs(Seconds_from_T1_to_T2);
  currentDebt = startAmount + (Seconds_Between_Dates * 2853.88);
  function numberWithCommas(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
  }
  var debtNum = currentDebt.toFixed(2);
  document.getElementById("studentLoanTotal").innerHTML = 'Student Loans : $' + numberWithCommas(debtNum);
  
  var getDebt = setInterval(function() {
  var startAmount = 883000000000;
  var t1 = new Date();
  var t2 = new Date(2010, 06, 01, 0, 0, 0, 0);
  var dif = t1.getTime() - t2.getTime();
  
  
  var Seconds_from_T1_to_T2 = dif / 1000;
  var Seconds_Between_Dates = Math.abs(Seconds_from_T1_to_T2);
  currentDebt = startAmount + (Seconds_Between_Dates * 2853.88);
  function numberWithCommas(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
  }
  var debtNum = currentDebt.toFixed(2);
  document.getElementById("studentLoanTotal").innerHTML = 'Student Loans : $' + numberWithCommas(debtNum);
  }, seconds * 1000);  

  } catch(e) { console.error(e); }
})();

})();
